import { createApp } from 'vue'
import App from './App.vue'
import '@/assets/css/output.css'
import "@/assets/libs/@mdi/font/css/materialdesignicons.min.css";
import '@/assets/libs/@iconscout/unicons/css/line.css'
import router from './router';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueSmoothScroll from 'vue3-smooth-scroll';

import ElementPlus from "element-plus";
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import "element-plus/dist/index.css";

import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import axios from "axios";
axios.defaults.baseURL = "https://api.zurihr.com/"; 


const app = createApp(App)
app.use(VueSmoothScroll);
app.use(VueSweetalert2);
app.use(router);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(ElementPlus)

app.use(pinia)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }

app.mount('#app')


    